class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary');

    // A11y: expose disclosure state to assistive tech and keep it in sync.
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open') ? 'true' : 'false');
      const panel = this.summary.nextElementSibling;
      if (panel && panel.id && !this.summary.hasAttribute('aria-controls')) {
        this.summary.setAttribute('aria-controls', panel.id);
      }
    }

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    if (!this.summary) return;
    this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open') ? 'true' : 'false');
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
